import axios from "axios";
import * as Constants from "../constant";
const setForgotPassword = async (value, UserId) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/userauth/${UserId}`,
			value
		);
		return response.data.res[0];
	} catch (error) {
		return error;
	}
};
export default setForgotPassword;
